import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import useSeo from '@/hooks/useSeo';

const IMG_HERO = 'https://readdy.ai/api/search-image?query=Extremely%20realistic%20professional%20industrial%20photography%20modern%20clean%20organized%20heavy%20industrial%20workshop%20with%20large%20machinery%20hydraulic%20equipment%20steel%20components%20metallic%20surfaces%20professional%20technicians%20in%20safety%20gear%20working%20not%20facing%20camera%20cinematic%20dramatic%20lighting%20gray%20silver%20steel%20tones%20with%20subtle%20warm%20yellow%20accent%20details%20wide%20angle%20widescreen%20composition%20premium%20high%20resolution%20sharp%20depth%20industrial%20maintenance%20engineering%20reliability%20heavy%20mechanics%20pulp%20paper%20mining%20oil%20gas%20sectors%20negative%20space%20for%20title%20overlay%20clean%20backgrounds%20not%20stock%20photo%20not%20illustration%20not%203D%20render&width=1600&height=700&seq=gp-cases-unified-hero-v2&orientation=landscape';
const IMG_VISAOG = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/9d7e248c-78a3-49a3-822e-c806f480e1c2_compressed_BOMBA-VACUO-BUSCH12.webp';
const IMG_DESAF = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/6f7bd6ab-4d7f-4462-b31c-8eac2391ffdc_compressed_BOMBA-VACUO-BUSCH1.webp';
const IMG_ESCOP = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/5ff4b4bd-e247-406e-b16a-d0f055b7f765_compressed_BOMBA-VACUO-BUSCH3.webp';
const IMG_INSPC = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/4b8f7cd7-ff96-4e36-9772-951100fc2cf6_compressed_BOMBA-VACUO-BUSCH4.webp';
const IMG_TESTE = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/c2d1207a-e81a-4fbd-a157-158a336fe7bb_compressed_BOMBA-VACUO-BUSCH15.webp';
const IMG_RESUL = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/98d29b28-254e-4904-ba03-644564dd39c0_compressed_BOMBA-VACUO-BUSCH2.webp';

const GAL_1 = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/6f7bd6ab-4d7f-4462-b31c-8eac2391ffdc_compressed_BOMBA-VACUO-BUSCH1.webp';
const GAL_2 = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/98d29b28-254e-4904-ba03-644564dd39c0_compressed_BOMBA-VACUO-BUSCH2.webp';
const GAL_3 = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/5ff4b4bd-e247-406e-b16a-d0f055b7f765_compressed_BOMBA-VACUO-BUSCH3.webp';
const GAL_4 = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/4b8f7cd7-ff96-4e36-9772-951100fc2cf6_compressed_BOMBA-VACUO-BUSCH4.webp';
const GAL_5 = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/9d7e248c-78a3-49a3-822e-c806f480e1c2_compressed_BOMBA-VACUO-BUSCH12.webp';
const GAL_6 = 'https://storage.readdy-site.link/project_files/93d54813-2fc1-4495-a318-6b5d36c5e53e/c2d1207a-e81a-4fbd-a157-158a336fe7bb_compressed_BOMBA-VACUO-BUSCH15.webp';

export default function CaseRecuperacaoBombaVacuoIndustrialPage() {
  useSeo({
    title: 'Recuperação de Bomba de Vácuo Industrial | Oficina Especializada | Grupo Pilar',
    description: 'Case de recuperação de bomba de vácuo industrial utilizada na fabricação de tubos flexíveis para petróleo e gás, incluindo desmontagem, inspeções, substituição de rolamentos e testes operacionais.',
    keywords: 'bomba de vácuo industrial, manutenção de bomba de vácuo, recuperação de bomba de vácuo, equipamentos rotativos, petróleo e gás, bomba BUSCH, manutenção industrial, oficina especializada, grupo pilar',
    canonical: 'https://www.pilarmanutencao.com.br/cases/recuperacao-bomba-vacuo-industrial',
    ogUrl: 'https://www.pilarmanutencao.com.br/cases/recuperacao-bomba-vacuo-industrial',
    ogImage: IMG_HERO,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gp-graphite">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative min-h-[60vh] flex items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src={IMG_HERO}
              alt="Bomba de vácuo industrial BUSCH recuperada pela Pilar — equipamento de grande porte para indústria de petróleo e gás"
              title="Bomba de Vácuo Industrial — Case Pilar"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gp-graphite/75"></div>
          </div>
          <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12 pt-28 pb-16">
            <div className="max-w-4xl">
              <div className="flex items-center gap-3 mb-6 flex-wrap">
                <span className="inline-block px-3 py-1 rounded-sm text-xs font-semibold uppercase tracking-wider bg-gp-yellow text-gp-graphite">
                  Oficina Especializada
                </span>
                <span className="text-gray-400 text-xs uppercase tracking-wider">Petróleo e Gás</span>
                <span className="text-gray-500 text-xs">— Aracruz, ES</span>
              </div>
              <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white uppercase leading-tight mb-6">
                <span className="text-gp-yellow">Case:</span>{' '}
                Recuperação de Bomba de Vácuo Industrial para Indústria de Petróleo e Gás
              </h1>
              <p className="text-gray-300 text-lg max-w-2xl leading-relaxed">
                Recuperação completa de bomba de vácuo industrial de grande porte utilizada no processo de fabricação de tubos flexíveis
                destinados ao setor de petróleo e gás, incluindo desmontagem controlada, inspeções técnicas detalhadas,
                substituição de rolamentos, instalação de peças originais e testes operacionais.
              </p>
            </div>
          </div>
        </section>

        {/* Visão Geral */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Visão Geral</h2>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-information-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Dados do Projeto</h3>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-settings-3-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Equipamento</span>
                        <p className="text-gray-300 text-sm">Bomba de Vácuo Industrial de Grande Porte</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-building-2-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Segmento</span>
                        <p className="text-gray-300 text-sm">Petróleo e Gás</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-tools-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Aplicação</span>
                        <p className="text-gray-300 text-sm">Sistema de vácuo utilizado na fabricação de tubos flexíveis para a indústria de petróleo e gás</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-team-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Equipe</span>
                        <p className="text-gray-300 text-sm">2 técnicos especializados</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-calendar-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Duração Aproximada</span>
                        <p className="text-gray-300 text-sm">2 dias de manutenção especializada</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-tools-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Disciplinas</span>
                        <p className="text-gray-300 text-sm">Mecânica Industrial, Equipamentos Rotativos, Inspeção Técnica</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-auto p-4 flex items-center justify-center">
                    <img
                      src={IMG_VISAOG}
                      alt="Bomba de vácuo industrial BUSCH na bancada de serviço da oficina especializada Pilar"
                      title="Bomba de vácuo industrial na oficina Pilar"
                      className="w-full h-auto object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Bomba de vácuo industrial BUSCH na bancada de serviço da oficina especializada Pilar
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Desafio */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Desafio</h2>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-alert-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-gray-300 text-base leading-relaxed mb-4">
                        A Pilar executou a recuperação completa de uma bomba de vácuo industrial de grande porte utilizada
                        em processo de fabricação de tubos flexíveis destinados ao setor de petróleo e gás.
                        O equipamento desempenha papel fundamental no processo produtivo e possui elevada criticidade operacional.
                      </p>
                      <p className="text-gray-400 text-sm leading-relaxed mb-4">
                        As principais complexidades envolviam:
                      </p>
                      <ul className="space-y-2 mb-4">
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Equipamento de alta precisão com componentes internos sujeitos a desgaste contínuo</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Necessidade de desmontagem controlada para preservação dos componentes críticos</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Inspeções técnicas detalhadas dos sistemas internos e conjuntos rotativos</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Substituição de componentes críticos com elevado grau de precisão</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Instalação de peças de reposição originais para garantia de desempenho</span>
                        </li>
                        <li className="flex items-start gap-2 text-gray-300 text-sm">
                          <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                          <span>Necessidade de retorno rápido à operação devido à criticidade do equipamento</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-auto p-4 flex items-center justify-center">
                    <img
                      src={IMG_DESAF}
                      alt="Câmara interna da bomba de vácuo em condição original — avaliação técnica do estado do lóbulo e carcaça"
                      title="Câmara interna da bomba de vácuo — condição encontrada"
                      className="w-full h-auto object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Câmara interna da bomba de vácuo — avaliação técnica da condição dos lóbulos e carcaça
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Escopo Executado */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Escopo Executado pela Pilar</h2>
              </div>

              <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite mb-8">
                <div className="h-auto p-4 flex items-center justify-center">
                  <img
                    src={IMG_ESCOP}
                    alt="Conjunto de engrenagens, eixos e rolamentos da bomba de vácuo desmontados para inspeção técnica"
                    title="Desmontagem da bomba de vácuo — componentes internos expostos"
                    className="w-full h-auto object-contain"
                    loading="lazy"
                  />
                </div>
                <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                  <p className="text-gray-400 text-xs text-center">
                    Conjunto de engrenagens, eixos e rolamentos desmontados da bomba de vácuo — protocolo de inspeção técnica
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">01</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Desmontagem completa da bomba de vácuo industrial na oficina especializada Pilar</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">02</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Inspeção dimensional detalhada de todos os componentes internos da bomba com instrumentação de precisão</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">03</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Inspeção dos sistemas internos com verificação de sincronismo e folgas operacionais</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">04</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Avaliação dos conjuntos rotativos quanto a desgastes e condições operacionais</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">05</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição de rolamentos conforme diagnóstico técnico das inspeções realizadas</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">06</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Substituição de componentes de desgaste identificados durante as inspeções técnicas</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">07</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Instalação de peças de reposição originais para garantia de qualidade e desempenho</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">08</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Montagem completa da bomba de vácuo com controle dimensional e ajustes de precisão</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite-light border border-gp-graphite-lighter rounded-lg p-5">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <span className="text-gp-yellow font-display font-bold text-sm">09</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-2">Ajustes finais de montagem com verificação de folgas e alinhamentos de precisão</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Inspeções Técnicas */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Inspeções Técnicas</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start mb-8">
                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-search-eye-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Protocolo de Inspeção</h3>
                    </div>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed mb-4">
                    Durante a recuperação da bomba de vácuo industrial, a Pilar executou um protocolo completo de inspeções técnicas
                    para garantir a identificação precisa de todos os componentes que necessitavam de intervenção, garantindo
                    a qualidade e confiabilidade do serviço executado.
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Verificação detalhada de componentes internos com instrumentação de precisão</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Avaliação dos sistemas de sincronismo da bomba de vácuo industrial</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Avaliação dos conjuntos rotativos quanto a desgastes e condições operacionais</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Verificação de folgas operacionais com tolerâncias controladas</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Inspeção de componentes sujeitos a desgaste com registro documental</span>
                    </li>
                  </ul>
                </div>

                <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-auto p-4 flex items-center justify-center">
                    <img
                      src={IMG_INSPC}
                      alt="Caixa de engrenagens aberta da bomba de vácuo industrial — inspeção de sincronismo e condição dos componentes rotativos"
                      title="Inspeção técnica da bomba de vácuo industrial"
                      className="w-full h-auto object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Caixa de engrenagens aberta — inspeção de sincronismo e condição dos componentes rotativos
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testes e Comissionamento */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Testes e Comissionamento</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="rounded-lg overflow-hidden border border-gp-graphite-lighter bg-gp-graphite">
                  <div className="h-auto p-4 flex items-center justify-center">
                    <img
                      src={IMG_TESTE}
                      alt="Rotores lóbulo da bomba de vácuo após montagem — verificação de alinhamento e folgas operacionais"
                      title="Teste de montagem dos rotores da bomba de vácuo"
                      className="w-full h-auto object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Rotores lóbulo montados na carcaça — verificação de alinhamento e folgas operacionais
                    </p>
                  </div>
                </div>

                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 md:p-8">
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-double-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Protocolo de Comissionamento</h3>
                    </div>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed mb-4">
                    Após a conclusão da montagem da bomba de vácuo industrial, a Pilar executou um protocolo completo
                    de testes e comissionamento para garantir o desempenho operacional e a confiabilidade do equipamento
                    recuperado antes do retorno ao cliente.
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Montagem final da bomba de vácuo com todos os componentes recuperados ou substituídos</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Testes operacionais com verificação de todos os parâmetros de funcionamento</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Validação de desempenho do sistema de vácuo com medições comparativas</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-300 text-sm">
                      <i className="ri-checkbox-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5"></i>
                      <span>Retorno ao cliente com equipamento validado e pronto para operação</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Recursos Envolvidos */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Recursos Envolvidos</h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 text-center">
                  <div className="w-14 h-14 bg-gp-yellow/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-team-line text-gp-yellow text-2xl w-8 h-8 flex items-center justify-center"></i>
                  </div>
                  <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Equipe</h3>
                  <p className="text-gp-yellow text-3xl font-display font-bold mb-2">2</p>
                  <p className="text-gray-400 text-sm">Técnicos especializados</p>
                </div>

                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 text-center">
                  <div className="w-14 h-14 bg-gp-yellow/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-calendar-line text-gp-yellow text-2xl w-8 h-8 flex items-center justify-center"></i>
                  </div>
                  <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Duração</h3>
                  <p className="text-gp-yellow text-3xl font-display font-bold mb-2">2</p>
                  <p className="text-gray-400 text-sm">Dias de manutenção especializada</p>
                </div>

                <div className="bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6 text-center">
                  <div className="w-14 h-14 bg-gp-yellow/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-tools-line text-gp-yellow text-2xl w-8 h-8 flex items-center justify-center"></i>
                  </div>
                  <h3 className="font-display text-lg font-bold text-white uppercase mb-2">Disciplinas</h3>
                  <p className="text-gp-yellow text-3xl font-display font-bold mb-2">3</p>
                  <p className="text-gray-400 text-sm">Mecânica, Rotativos, Inspeção Técnica</p>
                </div>
              </div>

              <div className="mt-8 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-6">
                <div className="flex items-center gap-3 mb-4">
                  <i className="ri-list-check text-gp-yellow w-6 h-6 flex items-center justify-center"></i>
                  <h3 className="font-display text-base font-bold text-white uppercase">Disciplinas Envolvidas</h3>
                </div>
                <div className="flex flex-wrap gap-3">
                  <span className="inline-flex items-center gap-2 bg-gp-graphite-light border border-gp-graphite-lighter px-4 py-2 rounded-lg text-gray-300 text-sm">
                    <i className="ri-settings-3-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    Mecânica Industrial
                  </span>
                  <span className="inline-flex items-center gap-2 bg-gp-graphite-light border border-gp-graphite-lighter px-4 py-2 rounded-lg text-gray-300 text-sm">
                    <i className="ri-refresh-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    Equipamentos Rotativos
                  </span>
                  <span className="inline-flex items-center gap-2 bg-gp-graphite-light border border-gp-graphite-lighter px-4 py-2 rounded-lg text-gray-300 text-sm">
                    <i className="ri-search-eye-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                    Inspeção Técnica
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Resultados */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Resultados Obtidos</h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                <div className="relative rounded-lg overflow-hidden border border-gp-yellow/20 bg-gp-graphite-light p-6 md:p-8 order-2 lg:order-1">
                  <div className="absolute top-0 left-0 w-1 h-full bg-gp-yellow"></div>
                  <div className="flex items-start gap-4 mb-6">
                    <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <i className="ri-trophy-line text-gp-yellow text-xl w-6 h-6 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <h3 className="font-display text-xl font-bold text-white uppercase mb-2">Resultados</h3>
                    </div>
                  </div>
                  <ul className="space-y-4">
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-refresh-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Equipamento Recuperado</span>
                        <p className="text-gray-400 text-sm">Bomba de vácuo recuperada com sucesso e retornada às condições operacionais</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-flashlight-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Eficiência Aumentada</span>
                        <p className="text-gray-400 text-sm">Aumento significativo da eficiência do sistema de vácuo industrial</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-arrow-up-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Capacidade Melhorada</span>
                        <p className="text-gray-400 text-sm">Melhoria expressiva da capacidade de geração de vácuo do equipamento</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-shield-check-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Maior Confiabilidade</span>
                        <p className="text-gray-400 text-sm">Confiabilidade operacional ampliada do processo produtivo de tubos flexíveis</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-timer-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Maior Disponibilidade</span>
                        <p className="text-gray-400 text-sm">Disponibilidade ampliada do equipamento para operação contínua</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                        <i className="ri-money-dollar-circle-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <span className="text-gp-yellow font-semibold text-sm">Redução de Custos</span>
                        <p className="text-gray-400 text-sm">Redução de custos em comparação à aquisição de uma nova bomba de vácuo industrial</p>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="rounded-lg overflow-hidden border border-gp-yellow/20 bg-gp-graphite order-1 lg:order-2">
                  <div className="h-auto p-4 flex items-center justify-center">
                    <img
                      src={IMG_RESUL}
                      alt="Bomba de vácuo industrial BUSCH totalmente recuperada e pronta para retorno à operação"
                      title="Bomba de vácuo industrial recuperada — resultado final"
                      className="w-full h-auto object-contain"
                      loading="lazy"
                    />
                  </div>
                  <div className="bg-gp-graphite-light p-3 border-t border-gp-graphite-lighter">
                    <p className="text-gray-400 text-xs text-center">
                      Bomba de vácuo industrial BUSCH totalmente recuperada e pronta para retorno à operação
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Diferenciais da Pilar */}
        <section className="relative py-20 bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Diferenciais da Pilar</h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-settings-3-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Capacidade de manutenção em equipamentos rotativos de alta precisão na oficina especializada</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-verified-badge-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Utilização de peças de reposição originais para garantia de qualidade e desempenho do equipamento</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-team-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Equipe especializada em equipamentos rotativos e inspeção técnica industrial</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-home-gear-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Estrutura adequada para equipamentos industriais de grande porte na oficina especializada</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-building-2-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Experiência em equipamentos críticos de processo com elevada criticidade operacional</p>
                </div>
                <div className="flex items-start gap-4 bg-gp-graphite border border-gp-graphite-lighter rounded-lg p-5 hover:border-gp-yellow/30 transition-colors duration-300">
                  <div className="w-10 h-10 bg-gp-yellow/10 rounded-sm flex items-center justify-center flex-shrink-0">
                    <i className="ri-search-eye-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">Processo completo de inspeção técnica com diagnóstico preciso e intervenções corretivas</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Galeria Técnica */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
                backgroundSize: '40px 40px',
              }}
            ></div>
          </div>
          <div className="relative z-10 px-4 sm:px-6 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase tracking-wider">Galeria Técnica</h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <div className="relative rounded-lg overflow-hidden border border-gp-graphite-lighter group bg-gp-graphite">
                  <div className="h-56 flex items-center justify-center p-4">
                    <img
                      src={GAL_1}
                      alt="Câmara interna da bomba de vácuo — inspeção técnica da condição dos lóbulos e carcaça"
                      className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gp-graphite/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-gray-300 text-xs text-center px-4">Câmara interna da bomba de vácuo — inspeção técnica da condição dos lóbulos e carcaça</span>
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 1</span>
                  </div>
                </div>
                <div className="relative rounded-lg overflow-hidden border border-gp-graphite-lighter group bg-gp-graphite">
                  <div className="h-56 flex items-center justify-center p-4">
                    <img
                      src={GAL_2}
                      alt="Bomba de vácuo industrial BUSCH em perfil — visão geral do equipamento recuperado"
                      className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gp-graphite/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-gray-300 text-xs text-center px-4">Bomba de vácuo industrial BUSCH em perfil — visão geral do equipamento recuperado</span>
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 2</span>
                  </div>
                </div>
                <div className="relative rounded-lg overflow-hidden border border-gp-graphite-lighter group bg-gp-graphite">
                  <div className="h-56 flex items-center justify-center p-4">
                    <img
                      src={GAL_3}
                      alt="Engrenagens, eixos e rolamentos desmontados da bomba de vácuo — protocolo de inspeção técnica"
                      className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gp-graphite/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-gray-300 text-xs text-center px-4">Engrenagens, eixos e rolamentos desmontados — protocolo de inspeção técnica</span>
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 3</span>
                  </div>
                </div>
                <div className="relative rounded-lg overflow-hidden border border-gp-graphite-lighter group bg-gp-graphite">
                  <div className="h-56 flex items-center justify-center p-4">
                    <img
                      src={GAL_4}
                      alt="Caixa de engrenagens aberta — verificação de sincronismo e condição dos componentes rotativos"
                      className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gp-graphite/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-gray-300 text-xs text-center px-4">Caixa de engrenagens aberta — verificação de sincronismo e condição dos componentes rotativos</span>
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 4</span>
                  </div>
                </div>
                <div className="relative rounded-lg overflow-hidden border border-gp-graphite-lighter group bg-gp-graphite">
                  <div className="h-56 flex items-center justify-center p-4">
                    <img
                      src={GAL_5}
                      alt="Bomba de vácuo na bancada de serviço da oficina Pilar — escopo de recuperação completo"
                      className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gp-graphite/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-gray-300 text-xs text-center px-4">Bomba de vácuo na bancada de serviço da oficina Pilar — escopo de recuperação completo</span>
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 5</span>
                  </div>
                </div>
                <div className="relative rounded-lg overflow-hidden border border-gp-graphite-lighter group bg-gp-graphite">
                  <div className="h-56 flex items-center justify-center p-4">
                    <img
                      src={GAL_6}
                      alt="Rotores lóbulo montados na carcaça — teste de alinhamento e folgas operacionais"
                      className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gp-graphite/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-gray-300 text-xs text-center px-4">Rotores lóbulo montados na carcaça — teste de alinhamento e folgas operacionais</span>
                  </div>
                  <div className="absolute bottom-2 left-2 bg-gp-graphite/80 px-2 py-1 rounded-sm">
                    <span className="text-gp-yellow text-xs font-semibold">Foto 6</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Serviços Relacionados */}
        <section className="relative py-16 bg-gp-graphite-light overflow-hidden border-t border-gp-graphite-lighter">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-[3px] bg-gp-yellow"></div>
                <h2 className="font-display text-lg font-bold text-white uppercase tracking-wider">Serviços Relacionados</h2>
              </div>
              <div className="flex flex-wrap gap-3">
                <Link
                  to="/mecanica-industrial"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Mecânica Industrial
                </Link>
                <Link
                  to="/recuperacao-bombas-hidraulicas"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Recuperação de Bombas
                </Link>
                <Link
                  to="/oficina"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Oficina Especializada
                </Link>
                <Link
                  to="/cases"
                  className="inline-flex items-center gap-2 bg-gp-graphite border border-gp-graphite-lighter hover:border-gp-yellow/30 px-5 py-3 rounded-lg text-gray-300 hover:text-gp-yellow text-sm font-medium transition-all duration-300"
                >
                  <i className="ri-arrow-right-line text-gp-yellow w-4 h-4 flex items-center justify-center"></i>
                  Mais Cases de Sucesso
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="relative py-20 overflow-hidden">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="relative rounded-xl overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-gp-yellow/20 to-gp-graphite"></div>
              <div className="absolute inset-0 bg-gp-graphite/60"></div>
              <div className="relative z-10 p-8 md:p-12 text-center">
                <h2 className="font-display text-2xl md:text-3xl font-bold text-white uppercase mb-4">
                  Precisa recuperar bombas de vácuo ou equipamentos rotativos industriais?
                </h2>
                <p className="text-gray-300 max-w-2xl mx-auto mb-8 leading-relaxed">
                  Conte com a estrutura completa da oficina especializada Pilar para recuperação de bombas de vácuo e equipamentos rotativos,
                  incluindo desmontagem controlada, inspeções técnicas, substituição de rolamentos e testes operacionais com peças de reposição originais.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <a
                    href="https://wa.me/5527993092922"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 bg-gp-yellow hover:bg-gp-yellow-dark text-gp-graphite px-8 py-4 rounded-full font-semibold text-sm uppercase tracking-wider transition-all duration-300 hover:scale-105 whitespace-nowrap"
                  >
                    <div className="w-10 h-10 bg-gp-graphite rounded-full flex items-center justify-center">
                      <i className="ri-whatsapp-line text-gp-yellow w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <span>Solicitar Orçamento</span>
                    <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
                  </a>
                  <Link
                    to="/contato"
                    className="inline-flex items-center justify-center gap-2 border border-gray-500 hover:border-gp-yellow text-gray-300 hover:text-gp-yellow px-8 py-4 rounded-full font-semibold text-sm transition-all duration-300 whitespace-nowrap"
                  >
                    <i className="ri-mail-line text-lg w-6 h-6 flex items-center justify-center"></i>
                    Falar com Especialista
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Back to Cases */}
        <section className="py-10 border-t border-gp-graphite-lighter bg-gp-graphite-light">
          <div className="px-4 sm:px-6 lg:px-12">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <Link
                to="/cases"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-gp-yellow transition-colors duration-300 text-sm uppercase tracking-wider"
              >
                <i className="ri-arrow-left-line w-5 h-5 flex items-center justify-center"></i>
                Voltar para Cases
              </Link>
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-gp-yellow transition-colors duration-300 text-sm uppercase tracking-wider"
              >
                <i className="ri-home-line w-5 h-5 flex items-center justify-center"></i>
                Voltar para Home
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />

      {/* Schema JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: 'Recuperação de Bomba de Vácuo Industrial para Indústria de Petróleo e Gás | Case Grupo Pilar',
            description: 'Case de recuperação de bomba de vácuo industrial utilizada na fabricação de tubos flexíveis para petróleo e gás, incluindo desmontagem, inspeções, substituição de rolamentos e testes operacionais.',
            image: IMG_HERO,
            author: {
              '@type': 'Organization',
              name: 'Grupo Pilar',
              url: 'https://www.pilarmanutencao.com.br',
            },
            publisher: {
              '@type': 'Organization',
              name: 'Grupo Pilar',
              logo: {
                '@type': 'ImageObject',
                url: '/images/MARCA/LOGO-GRUPO-PILAR/LOGO-GRUPO-PILAR.png',
              },
            },
            datePublished: '2025-11-20',
            dateModified: '2026-06-23',
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': 'https://www.pilarmanutencao.com.br/cases/recuperacao-bomba-vacuo-industrial',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: 'https://www.pilarmanutencao.com.br',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Cases de Sucesso',
                item: 'https://www.pilarmanutencao.com.br/cases',
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: 'Recuperação de Bomba de Vácuo Industrial para Indústria de Petróleo e Gás',
                item: 'https://www.pilarmanutencao.com.br/cases/recuperacao-bomba-vacuo-industrial',
              },
            ],
          }),
        }}
      />
    </div>
  );
}